<script>
import store from "@/store"

export default {
    name: "ReferralLanding",
    beforeRouteEnter: (to, from, next) => {
        if (to.params.code.match(/[\w]{5}/) && store.getters['auth/isGuest']) {
            store.commit('referral/code', to.params.code)
        }
        next({name: 'Home'})
    }
}
</script>
